import React, { useState } from "react";
import { Link } from "react-router-dom";
import LayoutOne from "../../layouts/LayoutOne";
import { DPO_CONTACT } from "../../config/lgpd";
import bannerBg from "../../assets/img/banner/banner_bg.jpg";

const SOLICITACOES_LGPD = [
  {
    value: "confirmacao",
    label: "Confirmação da existência de tratamento de dados",
    desc: "Saber se a empresa trata seus dados pessoais",
  },
  {
    value: "acesso",
    label: "Acesso aos dados pessoais",
    desc: "Obter cópia dos dados que temos sobre você",
  },
  {
    value: "correcao",
    label: "Correção de dados",
    desc: "Corrigir dados incompletos, inexatos ou desatualizados",
  },
  {
    value: "anonimizacao",
    label: "Anonimização, bloqueio ou eliminação",
    desc: "Dados desnecessários ou em excesso em relação à finalidade",
  },
  {
    value: "portabilidade",
    label: "Portabilidade dos dados",
    desc: "Transferir seus dados a outro fornecedor de serviço, quando aplicável",
  },
  {
    value: "revogacao",
    label: "Revogação do consentimento",
    desc: "Retirar o consentimento dado para determinado tratamento",
  },
  {
    value: "exclusao",
    label: "Exclusão dos dados pessoais",
    desc: "Solicitar a exclusão dos seus dados pessoais",
  },
];

const LgpdSolicitacoes = () => {
  const [tipo, setTipo] = useState("");
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [enviado, setEnviado] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const assunto = encodeURIComponent(
      `[LGPD] Solicitação: ${SOLICITACOES_LGPD.find((s) => s.value === tipo)?.label || tipo}`
    );
    const body = encodeURIComponent(
      `Nome: ${nome}\nE-mail: ${email}\n\nTipo de solicitação: ${SOLICITACOES_LGPD.find((s) => s.value === tipo)?.label || tipo}\n\nMensagem/Detalhes:\n${mensagem}`
    );
    window.location.href = `mailto:${DPO_CONTACT.email}?subject=${assunto}&body=${body}`;
    setEnviado(true);
  };

  return (
    <LayoutOne>
      <main className="fix">
        <section
          className="breadcrumb-area pt-130 pb-130"
          style={{
            backgroundImage: `url(${bannerBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-8 col-lg-10">
                <div className="breadcrumb-content text-center">
                  <h1 className="title">Solicitações LGPD</h1>
                  <p className="text-white-50">
                    Exercício dos seus direitos sob a Lei Geral de Proteção de Dados
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="pt-130 pb-130">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="mb-5">
                  <p className="lead">
                    Nos termos da LGPD (Lei nº 13.709/2018), você pode exercer
                    seus direitos em relação aos seus dados pessoais. Selecione
                    o tipo de solicitação, preencha os dados e envie. O
                    Encarregado de Proteção de Dados (DPO) da USYS Tecnologia
                    responderá em prazo adequado.
                  </p>
                  <p>
                    <strong>Contato do DPO:</strong>{" "}
                    <a href={`mailto:${DPO_CONTACT.email}`}>
                      {DPO_CONTACT.email}
                    </a>
                  </p>
                </div>

                {!enviado ? (
                  <form onSubmit={handleSubmit} className="contact-form-wrap">
                    <div className="form-grp mb-4">
                      <label className="form-label">
                        Tipo de solicitação <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select form-control"
                        value={tipo}
                        onChange={(e) => setTipo(e.target.value)}
                        required
                      >
                        <option value="">Selecione o direito que deseja exercer</option>
                        {SOLICITACOES_LGPD.map((s) => (
                          <option key={s.value} value={s.value}>
                            {s.label}
                          </option>
                        ))}
                      </select>
                      {tipo && (
                        <small className="text-muted d-block mt-1">
                          {SOLICITACOES_LGPD.find((s) => s.value === tipo)?.desc}
                        </small>
                      )}
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-grp mb-4">
                          <label className="form-label">
                            Nome completo <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Seu nome completo"
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-grp mb-4">
                          <label className="form-label">
                            E-mail <span className="text-danger">*</span>
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            placeholder="seu@email.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form-grp mb-4">
                      <label className="form-label">
                        Mensagem ou detalhes da solicitação
                      </label>
                      <textarea
                        className="form-control"
                        rows="5"
                        placeholder="Descreva sua solicitação ou informações adicionais que ajudem a identificar seu cadastro..."
                        value={mensagem}
                        onChange={(e) => setMensagem(e.target.value)}
                      />
                    </div>

                    <p className="small text-muted mb-4">
                      Ao enviar, seu cliente de e-mail será aberto com a
                      mensagem direcionada ao DPO. Envie o e-mail para
                      formalizar sua solicitação. O prazo de resposta é de até
                      15 (quinze) dias, nos termos da LGPD.
                    </p>

                    <div className="submit-btn">
                      <button type="submit" className="btn theme-btn">
                        Abrir e-mail para o DPO
                      </button>
                    </div>
                  </form>
                ) : (
                  <div className="alert alert-success">
                    <h5>Próximo passo</h5>
                    <p className="mb-0">
                      Se o seu cliente de e-mail abriu, envie a mensagem para{" "}
                      <strong>{DPO_CONTACT.email}</strong>. Caso não tenha
                      aberto, envie um e-mail diretamente para esse endereço
                      informando o tipo de solicitação e seus dados.
                    </p>
                    <p className="mt-3 mb-0">
                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => setEnviado(false)}
                      >
                        Preencher novamente
                      </button>
                    </p>
                  </div>
                )}

                <div className="mt-5 pt-4 border-top">
                  <Link to="/politica-de-privacidade" className="btn btn-outline-primary me-2">
                    Ver Política de Privacidade
                  </Link>
                  <Link to="/" className="btn btn-outline-secondary">
                    Voltar ao início
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </LayoutOne>
  );
};

export default LgpdSolicitacoes;
